import { computed } from 'vue'
import { useStorage } from '@vueuse/core'
import { LAYOUT_TYPE_KEY, LayoutType, layoutTypes } from '@/enum/layout'

/* Data */
const layoutType = useStorage<LayoutType>(LAYOUT_TYPE_KEY, layoutTypes.TABBED)

/* Computed */
export const isListLayout = computed(() => {
    return layoutType.value === layoutTypes.LIST
})
export const isTabbedLayout = computed(() => {
    return layoutType.value === layoutTypes.TABBED
})
export const getCurrentLayoutType = computed(() => {
    return layoutType.value
})

/* Methods */
export function setLayoutType (type: LayoutType) {
    layoutType.value = type
}
